import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./EncounterDetail.css";
import { Accordion, AccordionDetails, AccordionSummary, Tooltip } from "@mui/material";
import { ArrowBack, ExpandMore } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetPatientById } from "../../../hooks/ReactQueryHooks/useGetPatientById";
import moment from "moment";
import { usePatientEncounterHistoryQuery } from "../../../hooks/ReactQueryHooks/usePatientEncounterHistoryQuery";
import { useEncounterQuestionnaireResponseQuery } from "../../../hooks/ReactQueryHooks/useQuestionnaireResponseQuery";
import { useSelector } from "react-redux";
import { Button } from "../../common/Button";
import ServiceLocationModal from "../ServiceRequest/ServiceLocationModal";
import html2pdf from "html2pdf.js";
import { axios } from "../../../lib/axios";
import { getDiscover, getOrganization, getOrganizationSettings } from "../../api/Organization";
import { failed, success } from "../../common/Toastify";
import {
  getSingleUser,
  getPractitionerForReport,
  getPatientData,
} from "../../api/Individual";
import { imageURLToBase64 } from "../../../utils/ImageToBase64";
import { getPractitionerSignatureSource } from "../../../utils/signatureSupport";
import { formatStoredPhoneForDisplay } from "../../../utils/phoneNumberSupport";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import {
  ViewDate,
  ViewTime,
  ViewDateTime,
  ViewDateTz,
  ViewTimeTz,
  ViewDateTimeTz,
  safeAgeString,
} from "../../../utils/DateSupport";
import { getServiceLineById } from "../../api/ServiceLine";
import { createDocument } from "../api/commonApis.js";
import AddendumModal from "./AddendumModal.js";
import { UpdateEncounterDocumentation } from "./UpdateEncounterDocumentation.js";
// import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts.js";
import { getProtocolResponsesByEncounterId } from "../api/Protocol/index.js";
import UpdateProtocolAssessmentModal from "./UpdateProtocolAssessmentModal.js";
import { confidentialStatement, internalReferralTypeLabels } from "./Constants.js";
import { getCTIDataByEncounterId  } from "../../api/CTI/index.js";
import ConfirmationModal from "../../common/ConfirmationModal";

{
  /* This file replaces the EncounterDetail.js file. It removes whitespace between the components to reduce the size of encounter report */
}

const EncounterReport = ({
  PractionerData,
  EncounterId,
  setEncouterDetailsShow = null,
  ShowCompleteButton = false,
}) => {
  const navigate = useNavigate();
  const [patientData, setPatientData] = useState(null);
  const [encounteredData, setEncounteredData] = useState([]);
  const [encounterQuestionnaireData, setEncounterQuestionnaireData] = useState([]);
  const { state } = useLocation();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [patientId, setPatientId] = useState(null);
  const [encounterOrgId, setEncounterOrgId] = useState(null);
  const [practitionerId, setPractitionerId] = useState(null);
  const [practionerData, setPractionerData] = useState({});
  const [myUserId, setMyUserId] = useState("");
  const encounterId =
    state?.encounterId || urlParams.get("encounterId") || EncounterId;
  const from = state?.from;
  const notPatientDashboard = state?.notPatientDashboard;
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const isSuperAdmin = userRoles?.includes("Super-Admin");
  const [openModal, setOpenModal] = useState(false);
  const [base64Url, setBase64Url] = useState("");
  const user = useSelector((state) => state?.auth?.user);
  const [organization, setOrganization] = useState({});
  const [practitionerDetails, setPractitionerDetails] = useState([]);
  const [base64SignImg, setBase64SignImg] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const [addendumModalShow, setAddAddendumModalShow] = useState(false);
  const [UpdateEncounterModalShow, setUpdateEncounterModalShow] = useState(false);
  // const { isFetched, data: orgLicensedProducts } = useGetOrgLicensedProducts(
  //   {}
  // );
  const [orgLicensedProducts, setOrgLicensedProducts] = useState(null);
  const permissions = useSelector((state) => state?.auth?.user?.permissions);
  const isContactCenterActive = orgLicensedProducts?.callCenter;
  const [isCTIEnabled, setIsCTIEnabled] = useState(false);
  //const isCTIEnabled = organizations?.ctiSettings?.enabled;
  const [protocolResponseData, setProtocolResponseData] = useState(null);
  const [finalDisposition, setFinalDisposition] = useState(null);
  const [protocolAssessmentUpdateModal, setProtocolAssessmentModal] =
    useState(false);
  const [ctiMetadata, setCTIMetadata] = useState([]);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [internalReferrals, setInternalReferrals] = useState([]);
  const [orgSettings, setOrgSettings] = useState({});
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [reportTimezone, setReportTimezone] = useState(null);
  /** While true, tz formatters must not run with a null tz (that renders as UTC in DateSupport). */
  const [timezoneFetchPending, setTimezoneFetchPending] = useState(false);
  const practUserName = useSelector(
    (state) => state?.auth?.user?.name[0]?.text
  );

  const onSuccessForEncounterQuestionnaireResponseQuery = async (data) => {
    setEncounterQuestionnaireData(data);
  };

  const { refetch } = useEncounterQuestionnaireResponseQuery({
    onSuccess: onSuccessForEncounterQuestionnaireResponseQuery,
    encounterId,
  });

  // FRD: source encounter report must list internal referrals created from it
  useEffect(() => {
    if (!patientId || !encounterId) return;
    axios
      .get(`servicerequest?patientId=${patientId}`)
      .then((res) => {
        const referrals = (res?.data ?? [])
          .filter(
            (obj) =>
              obj?.internalReferral === true &&
              obj?.encounter?.reference === `Encounter/${encounterId}`
          )
          .sort((a, b) => (a?.createdAt || 0) - (b?.createdAt || 0));
        setInternalReferrals(referrals);
      })
      .catch(() => {});
  }, [patientId, encounterId]);

  const hasServiceRequestDelivery = encounteredData?.documentDelivery?.some(
    (delivery) => delivery?.type !== "PHARM" && delivery?.type !== "HOSP"
  );

  useEffect(() => {
    const ref =
      encounteredData?.serviceProvider?.reference ||
      encounteredData?.managingOrganization?.reference;

    if (!ref) return undefined;

    const orgId = ref.split("/")?.[1];
    const serviceLineId =
      encounteredData?.serviceLineId ||
      encounteredData?.serviceLine?.reference?.split("/")?.[1];

    let cancelled = false;
    setTimezoneFetchPending(true);

    const fetchData = async () => {
      try {
        const orgRes = await getOrganization(orgId);
        if (cancelled) return;
        setOrganization(orgRes.data);
        setIsCTIEnabled(orgRes?.data?.ctiSettings?.enabled);

        const orgTimezone = orgRes?.data?.timeZone?.value;

        if (serviceLineId) {
          try {
            const serviceLineRes = await getServiceLineById(orgId, serviceLineId);
            if (cancelled) return;
            const serviceLineTimezone = serviceLineRes?.data?.timeZone?.value;

            const resolvedTimezone = serviceLineTimezone || orgTimezone;
            if (resolvedTimezone) setReportTimezone(resolvedTimezone);
          } catch {
            if (cancelled) return;
            if (orgTimezone) setReportTimezone(orgTimezone);
          }
        } else {
          if (orgTimezone) setReportTimezone(orgTimezone);
        }

        getDiscover(orgId)
          .then((res) => {
            if (cancelled) return;
            setOrgLicensedProducts(res?.data?.licensedProduct || []);
          })
          .catch(() => {});
      } catch (res) {
        if (!cancelled) {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res.message
          );
        }
      } finally {
        if (!cancelled) {
          setTimezoneFetchPending(false);
        }
      }

      getOrganizationSettings(orgId)
        .then((res) => {
          if (cancelled) return;
          if (res?.status === true) setOrgSettings(res?.data);
        })
        .catch(() => {});
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [encounteredData]);

  const dateTzReport = (date) =>
    timezoneFetchPending ? "-" : ViewDateTz(date, reportTimezone) || "-";
  const timeTzReport = (date) =>
    timezoneFetchPending ? "-" : ViewTimeTz(date, reportTimezone) || "-";
  const dateTimeTzReport = (date) =>
    timezoneFetchPending ? "-" : ViewDateTimeTz(date, reportTimezone);

  useEffect(() => {
    if (from === "fromServiceReq")
      localStorage.setItem("activeTableKey", "seventh");
    else if (from === "fromMedicationReq")
      localStorage.setItem("activeTableKey", "eighth");
    else if (from === "pastEncounter")
      localStorage.setItem("activeTableKey", "fifth");
  }, []);

  useEffect(() => {
    const apiBody = {
      id: user?.["custom:unique_id"],
      type: "Practitioner",
      userOrgId: adminOrgs?.[0]?.id,
    };
    getSingleUser(apiBody)
      .then((res) => {
        setPractionerData(res?.data);
        setMyUserId(res?.data?.link?.[0]?.target?.reference?.split("/")?.[1]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (encounterId) {
        setLoadingData(true);
        try {
          const response = await axios.get(`encounter/${encounterId}`);
          const encounterData = response?.data;
          let patientId = encounterData?.subject?.reference
            ? encounterData?.subject?.reference?.split("/")[1]
            : "";
          let lastPractionerId =
            encounterData.statusHistory
              .find((entry) => entry.status === "follow-up")
              ?.actor.reference.split("/")[1] ||
            encounterData.statusHistory[encounterData.statusHistory.length - 1] ?.actor?.reference?.split("/")[1] ||
            "";
          setEncounteredData(response?.data);
          setEncounterOrgId(encounterData?.serviceProvider?.reference?.split("/")?.[1] || encounterData?.managingOrganization?.reference?.split("/")?.[1]);
          if (patientId) {
            setPatientId(patientId);
            fetchPatient(patientId);
          }else{
            if(encounterData.status !== "cancelled" && encounterData.status !== "finished" && !encounterData?.serviceLine){
              setShowCancelButton(true);
            }
          }

          if (lastPractionerId) {
            fetchPractitioner(lastPractionerId);
          }
        } catch (error) {
          console.error("Error:", error);
        }
        setLoadingData(false);
      }
    };
    fetchData();
  }, [addendumModalShow]);

  const handleSendDocument = async () => {
    const element = document.getElementById("encounter-detail");

    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      .small-font-encounter-report { font-size: 10px !important; }
      .big-font-encounter-report { font-size: 10px !important; }
    `;
    document.head.appendChild(styleElement);

    try {
      const logoImg = document.querySelector(".circular-image");
      if (logoImg && organization?.organizationLogo?.url) {
        const base64Logo = await imageURLToBase64(organization.organizationLogo.url);
        logoImg.src = base64Logo;
      }
      const pdfDataUri = await html2pdf()
        .from(element)
        .set({
          margin: [0.25, 0.25, 0.25, 0.25],
          filename: `Encounter/${encounterId}`,
          image: { type: "jpeg", quality: .4 },
          html2canvas: { scale: 3, useCORS: true, letterRendering: true },
          jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
          pagebreak: {
            mode: ["avoid-all", "css"],
            before: [".service-info-block", ".questions-wrapper"],
            avoid: [".header", ".common-listing"],
          },
        })
        .toPdf()
        .output("datauristring");

      const base64String = pdfDataUri.split(",")[1];
      setBase64Url(base64String);
      setOpenModal(true);
    } catch (err) {
      failed(err?.message || "Failed to generate PDF.");
    }
  };

  const handleCancelRequest = () => {
    setConfirmModalShow(true);
  };

  const handleCancelConfirm = async () => {
      setConfirmModalShow(false); 
      const actor = {
        display: practionerData.name[0].text,
        reference: `Practitioner/${myUserId}`,
        type: "Practitioner",
      };
      const newParticipant = {
        individual: {
          reference: `Practitioner/${myUserId}`,
          display: practUserName,
          type: "Practitioner",
        },
        period: {
          start: encounteredData?.period?.start,
          end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
        },
      };
      const updatedParticipant = [...encounteredData?.participant, newParticipant];
      return axios
        .put(`encounter/${encounterId}`, {
          subject: encounteredData?.subject,
          status: "cancelled",
          actor: actor,
          period: {
            start: encounteredData?.period.start,
            end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
          },
          participant: updatedParticipant,
          class: "NULL",
        })
        .then((res) => {
          if (res?.status === true) {
            success("Encounter Cancelled Successfully");
            setShowCancelButton(false);
          }
        })
        .catch((err) =>
          console.log(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              err?.message
          )
        )
        .finally(() => {});
  };

  const fetchPractitioner = async (practitionerId) => {
    await getPractitionerForReport({ practitionerId: practitionerId })
      .then((practitioner) => {
        setPractitionerDetails(practitioner?.result);
        setPractitionerId(practitionerId);
        setBase64SignImg(getPractitionerSignatureSource(practitioner?.result?.signatureURL));
      })
      .catch((error) => {
        failed(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            error.message
        );
      });
  };

  const fetchPatient = async (patientId) => {
  return await getPatientData(patientId)
    .then((res) => {
      setPatientData(res?.result);
      return res?.result;
    })
    .catch((error) => {
      failed(error?.response?.data?.message || error?.response?.data?.error || error.message);
      return null;
    });
  };

  async function imageURLToBase64(url) {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      });
      const blob = await response.blob();
      const base64String = await blobToBase64(blob);
      return base64String;
    } catch (error) {
      console.error("Error converting image URL to base64:", error);
      throw error;
    }
  }

  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }
  const capitalizeWords = (str) => {
    if (str) {
      return str
        .toLowerCase()
        .replace(/(^|\s)\S/g, (firstLetter) => firstLetter.toUpperCase());
    } else {
      return "";
    }
  };

  const renderSourceTag = (source) => {
    if (!source) return null;
    const sources = Array.isArray(source) ? source : [source];
    
    return (
      <>
        {sources.map((src, index) => (
          <Tooltip key={index} title="Patient retrieved from external source" arrow>
            <span 
              style={{
                display: "inline-block", 
                marginLeft: "8px", 
                padding: "2px 6px", 
                backgroundColor: "#e0e0e0", 
                color: "#666", 
                fontSize: "11px", 
                borderRadius: "3px", 
                fontWeight: "500"
              }}
            >
              {src}
            </span>
          </Tooltip>
        ))}
      </>
    );
  };
  function hasRelevantAnswer(encounter) {
    // Check if encounter and encounter.item exist and are valid arrays
    if (!encounter || !Array.isArray(encounter.item)|| encounter?.author?.type !== "Practitioner") {
      return false;
    }

    // Iterate through each item in the encounter
    for (const data of encounter.item) {
      // Check if data.answer exists and is an array
      if (Array.isArray(data.answer)) {
        // Check if the first answer has a non-empty valueString
        if (data.answer[0]?.valueString) {
          return true;
        }

        // Check if any answer has valueBoolean set to true
        if (data.answer.some((ele) => ele?.valueBoolean === true)) {
          return true;
        }
      }
    }

    // If none of the items meet the conditions, return false
    return false;
  }

  const handleCompleteEncounter = async () => {
    let fetchedPatient = await fetchPatient(patientId);
    const actor = {
      display: practionerData.name[0].text,
      reference: `Practitioner/${myUserId}`,
      type: "Practitioner",
    };
    let subject = encounteredData?.subject;
    if(subject){
      subject.display = capitalizeWords(fetchedPatient?.name?.[0]?.text) || subject?.display;
    }
    const newParticipant = {
      individual: {
        reference: `Practitioner/${myUserId}`,
        display: practUserName,
        type: "Practitioner",
      },
      period: {
        start: encounteredData?.period?.start,
        end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
      },
    };
    const updatedParticipant = [...encounteredData?.participant, newParticipant];
    return axios
      .put(`encounter/${encounterId}`, {
        subject: subject,
        status: "finished",
        actor: actor,
        period: {
          start: encounteredData?.period.start,
          end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
        },
        participant: updatedParticipant,
        class: "NULL",
      })
      .then((res) => {
        if (!patientId) {
          failed("Something went wrong");
          navigate("/app/dashboard");
        }
        else {
          navigate(0)
        }
      })
      .catch((err) =>
        console.log(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message
        )
      )
      .finally(() => {});
  };

  const handleUpdateEncounterModalShow = () => {
    setUpdateEncounterModalShow((prev) => !prev);
    if (UpdateEncounterModalShow) {
      setLoadingData(true);
      refetch().finally(() => setLoadingData(false));
    }
  };

  const handleUpdateProtocolClick = () => {
    setProtocolAssessmentModal((prev) => !prev);
  };

  useEffect(() => {
    if (
      isContactCenterActive &&
      permissions.includes("Read Protocol Response") &&
      encounteredData?.orgId 
    ) {
      getProtocolResponsesByEncounterId(encounterId, encounteredData?.orgId)
        .then((res) => {
          const parsedResponse = JSON.parse(res?.body);
          if (parsedResponse?.data && parsedResponse?.data?.length > 0) {
            setProtocolResponseData(parsedResponse?.data);
            // Filter out the See More Appropriate Guideline
            const filteredData = parsedResponse.data.filter(
              (item) => item.dispositionLevel !== 99
            );

            const finalDisposition = filteredData.reduce((highest, item) => {
              return item.dispositionLevel > (highest?.dispositionLevel || 0)
                ? item
                : highest;
            }, null);
            setFinalDisposition(
              finalDisposition?.overrideDisposition ||
                finalDisposition?.disposition
            );
          }
        })
        .catch((res) => {
          failed(res?.data?.message || res?.message);
        });
    }
  }, [encounterQuestionnaireData, protocolAssessmentUpdateModal, orgLicensedProducts]);

  const extractPlainText = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };

  // Extract patient name from encoutner.subject when encounter is finished
  // Covers use case when encounter is in progress and patient profile is updated
  // Patient name will be stamped to encounter when it is marked as finished
  const patientName = encounteredData?.subject?.encounterWasEnriched ? (capitalizeWords(encounteredData?.subject?.name?.[0]?.text) || capitalizeWords(encounteredData?.subject?.display || "-")) : (encounteredData?.status === "finished" && capitalizeWords(encounteredData?.subject?.display) || capitalizeWords(patientData?.name?.[0]?.text) || "-");
  const preferredChannel = capitalizeWords(
        encounteredData?.intakeQuestions?.preferredChannel
      ) || "-";
  const patientDOB = (() => {
      const dob = encounteredData?.subject?.encounterWasEnriched ? encounteredData?.subject?.birthDate : patientData?.birthDate;
      if (!dob) return "-";
      const formattedDate = ViewDate(dob);
      if (!formattedDate) return "-";
      
      // Age calculation function
      const calculateAge = (birthDate) => {
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
          age--;
        }
        return age;
      };
    
      return `${formattedDate} ${formattedDate !== "-" ? `(${calculateAge(dob)} years)`:""}`;
    });
  const returnPhone = () => {
        const phoneEntry = encounterQuestionnaireData
          ?.flatMap(encounter => encounter.item)
          ?.find(item => item.text?.trim() === "Return Telephone Number");

        const fromQuestionnaire = phoneEntry?.answer?.[0]?.valueString;
        if (fromQuestionnaire) return formatStoredPhoneForDisplay(fromQuestionnaire);

        const callerNumber = encounteredData?.intakeQuestions?.callerNumber;
        const callerNumberExt = encounteredData?.intakeQuestions?.callerNumberExt;
        if (callerNumber) {
          const formatted = formatStoredPhoneForDisplay(callerNumber);
          return callerNumberExt
            ? `${formatted} ext. ${callerNumberExt}`
            : formatted;
        }

        return "-";
      }
  const designation = capitalizeWords(
        practitionerDetails?.designation === "nursePractitioner"
          ? "Nurse Practitioner"
          : practitionerDetails?.designation
      ) || "-";
  
  const caller = () => {
        const callerEntry = encounterQuestionnaireData
          ?.flatMap(encounter => encounter.item)
          ?.find(item => item.text?.trim() === "Caller Name");
        
        const callerName = callerEntry?.answer?.[0]?.valueString
          || encounteredData?.intakeQuestions?.callerName;
        const patientName = patientData?.name?.[0]?.text || "";
        return callerName && callerName !== patientName 
          ? capitalizeWords(callerName) 
          : "-";
      };

  const relationship = () => {
        const relationshipEntry = encounterQuestionnaireData
          ?.flatMap(encounter => encounter.item)
          ?.find(item => item.text?.trim() === "Relationship to Patient");
        
        const relationship = relationshipEntry?.answer
          ?.find(ans => ans.valueString)?.option
          || encounteredData?.intakeQuestions?.callerRelationship;
        
        return relationship || "-";
      }
  
  const encounterHash = {
    encounterId: {
      label: "Encounter ID",
      value: encounterId
    },
    patientName: {
      label: "Patient Name",
      value: patientName
    },
    encounterDate: {
      label: "Encounter Date",
      value: dateTzReport(encounteredData?.period?.end),
    },
    patientIdentifier: {
      label: "Patient Identifier",
      value: encounteredData?.subject?.encounterWasEnriched ? (encounteredData?.subject?.identifier?.find((ele) => ele?.type === "HCN")?.value || "-") : (patientData?.identifier?.find((ele) => ele?.type === "HCN")?.value || "-"),
    },
    preferredChannel: {
      label: "Preferred Channel",
      value: preferredChannel
    },
    completionTime: {
      label: "Completion Time",
      value: timeTzReport(encounteredData?.period?.end),
    },
    patientDOB: {
      label: "Patient DOB",
      value: patientDOB()
    },
    address: {
      label: "Address",
      value: encounteredData?.subject?.encounterWasEnriched ? (encounteredData?.subject?.address?.[0]?.line?.[0] || "-") : (patientData?.address?.[0].line?.[0] || "-")
    },
    providerName: {
      label: "Provider Name",
      value:  capitalizeWords(practitionerDetails?.name?.[0]?.text) || "-"
    },
    gender: {
      label: "Gender",
      value: encounteredData?.subject?.encounterWasEnriched ? (capitalizeWords(encounteredData?.subject?.gender) || "-") : (capitalizeWords(patientData?.gender) || "-")
    },
    returnPhone: {
      label: "Return Telephone Number",
      value: returnPhone()
    },
    designation: {
      label: "Provider Designation",
      value: designation
    },
    phone: {
      label: "Phone Number",
      value: encounteredData?.subject?.encounterWasEnriched ? (encounteredData?.subject?.telecom?.find((ele) => ele?.system === "phone")?.value || "-") : (patientData?.telecom?.find((ele) => ele?.system === "phone")?.value || "-")
    },
    caller: {
      label: "Caller Name",
      value: caller()
    },
    relationship: {
      label: "Relationship to Patient",
      value: relationship()
    },
    serviceLine: {
      label: "Service Line",
      value: encounteredData?.serviceLine?.display || "-"
    },
    orgName: {
      label: "Organization Name",
      value: encounteredData?.serviceProvider?.display || encounteredData?.managingOrganization?.display || "-"
    },
    disposition: {
      label: "Disposition",
      value: finalDisposition || "-"
    }
  };

  // Identify if a questionnaire response is the intake QR and has been edited
  const intakeQuestionnaireResponseId =
    encounteredData?.intakeQuestions?.questionnaireResponseId?.reference
      ?.split("/")
      ?.at(-1) || null;

  const isEditedIntakeQuestionnaire = (encounter) => {
    if (!intakeQuestionnaireResponseId) return false;
    if (!encounter?.id || encounter.id !== intakeQuestionnaireResponseId) return false;
    if (!encounter?.authored || !encounter?.updatedAt) return false;
    return Math.abs(encounter.updatedAt - encounter.authored) > 5000;
  };

  useEffect(() => {
    if (isCTIEnabled && encounteredData?.orgId) {
      getCTIDataByEncounterId(encounterId, encounteredData?.orgId).then((res) => {
        const sortedItems = res?.data?.Items?.sort((a, b) => {
        const dateA = new Date(a?.startTime);
        const dateB = new Date(b?.startTime);
        return dateB - dateA; 
      });
      setCTIMetadata(sortedItems);
      })
    }
  }, [encounteredData, isCTIEnabled]) 

  const hasProtocolContent = (protocols) =>{
    if(Array.isArray(protocols) && protocols.length > 0){
      return protocols.some((item) => {
      return (item?.initialAssessment?.length > 0) ||
          (item?.positiveIndicators?.length > 0) ||
          (item?.careAdvice?.length > 0);
      });
    }
    return false;
  }

  if (loadingData) return <FullPageSpinner loadingText="Loading" />;

  return (
    <>
      <ConfirmationModal
          show={confirmModalShow}
          onConfirm={handleCancelConfirm}
          onCancel={() => setConfirmModalShow(false)}
          message="Are you sure you want to cancel this encounter?"
      />
      {openModal ? (
        <ServiceLocationModal
          onHide={() => {
            document.head.removeChild(document.head.lastElementChild)
            setOpenModal(false)
          }}
          modalShow={openModal}
          paramsObj={{
            patientId,
            orgId: organization?.id,
            base64: base64Url,
          }}
          practitionerData={user}
          requestType={"Encounter Report"}
          categoryVar={"Encounter Report"}
          patientData={patientData}
          orgName={organization?.name}
          fromServiceRequest={false}
          fromMedicationRequest={false}
          fromEncounter={true}
          encounterId={encounterId}
          documentName={`encounter-${encounterId}`}
          encounterOrgId={encounterOrgId}
        />
      ) : null}

      {UpdateEncounterModalShow ? (
        <UpdateEncounterDocumentation
          modalShow={UpdateEncounterModalShow}
          handleShow={handleUpdateEncounterModalShow}
          encounterId={encounterId}
          patientId={patientId}
          orgId={encounteredData?.orgId}
        />
      ) : null}

      {protocolAssessmentUpdateModal && (
        <UpdateProtocolAssessmentModal
          encounterId={encounterId}
          onShow={protocolAssessmentUpdateModal}
          onHide={() => setProtocolAssessmentModal(false)}
        />
      )}

      {addendumModalShow && (
        <AddendumModal
          data={encounteredData}
          onShow={addendumModalShow}
          onHide={() => setAddAddendumModalShow(false)}
        />
      )}
      <section className="common-listing" style={{ paddingTop: "0px" }}>
        {/* Fixed Header that contains buttons – hidden for Super Admin (read-only) */}
        {!isSuperAdmin && (
        <div
          className="heading-wrap mb-3 d-flex align-items-center justify-content-between header-wrap"
          style={{ position: "sticky", padding: "10px", zIndex: 2 }}
        >
          <div className="page-title-block d-flex align-items-center"></div>
          <div className="d-flex align-items-center">
            {encounteredData?.status === "in-progress-waitingroom" && patientId && (
              <>
                <Button
                  className="me-3"
                  onClick={handleUpdateEncounterModalShow}
                >
                  Update Documentation
                </Button>
              </>
            )}
            {isContactCenterActive &&
              permissions.includes("Write Protocol Response") &&
              protocolResponseData?.length > 0 &&
              encounteredData?.status === "in-progress-waitingroom" && patientId && (
                <>
                  <Button className="me-3" onClick={handleUpdateProtocolClick}>
                    Update Triage Documentation
                  </Button>
                </>
              )}
            {(encounteredData?.status === "in-progress-appointment" ||
              encounteredData?.status === "in-progress-waitingroom" ||
              encounteredData?.status === "in-progress-intake") && patientId && (
              <>
                <Button
                  className="me-3"
                  style={{
                    background:
                      "linear-gradient(90deg, #4CAF50 0%, #388E3C 100%)",
                  }}
                  onClick={handleCompleteEncounter}
                >
                  Complete
                </Button>
              </>
            )}
            {showCancelButton && (
              <Button className="me-3" onClick={handleCancelRequest}>
                    Cancel
              </Button>
            )}

            {encounteredData?.status === "finished" && (
              <>
                <Button
                  onClick={() => navigate("/app/dashboard")}
                  style={{ marginRight: "10px" }}
                >
                  My Dashboard
                </Button>
                {organization?.isWaitingRoom && (
                  <Button
                    onClick={() => navigate("/app/waiting-room")}
                    style={{ marginRight: "10px" }}
                  >
                    Waiting Room
                  </Button>
                )}
                <Button
                  onClick={() => setAddAddendumModalShow(true)}
                  style={{ marginRight: "10px" }}
                >
                  Add Addendum
                </Button>
                {organization?.sft?.enabled && (
                  <Button
                    onClick={() =>
                      organization?.sft?.locationDelivery
                        ? handleSendDocument()
                        : failed("Please enable delivery to location to send document")
                    }
                  >
                    Send Document
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
        )}
        <section id="encounter-detail">
          {/* Organization Letter Head */}
          <div style={{ textAlign: "center" }}>
            {/* Organization Name and logo on right*/}
            <div style={{ display: "flex", textAlign: "center",flexDirection:"row" ,justifyContent:"center"}}>
              <span
                className="user-name-title fw-bold big-font-encounter-report"
                style={{ display: "inline-block", alignSelf:"center" , width: "100%" }}
              >
                {encounterHash?.orgName?.value} - Encounter Report
              </span>
              <div className="circular-container" style={{ alignSelf: "flex-end" }}>
                  <img src={organization?.organizationLogo?.url} className="circular-image" />
              </div>

            </div>
            <hr
              style={{
                margin: "2px 0",
                borderWidth: "2px",
                borderColor: "black",
              }}
            />

            {/* Confidential Statement */}
            <div
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <p
                className="label-grey small-font-encounter-report"
                style={{
                  margin: "0",
                  padding: "0",
                  flex: 1,
                  textAlign: "left",
                }}
              >
                {orgSettings?.encounterReportPrivacyStatement || confidentialStatement}
              </p>
              
            </div>

            <hr
              style={{
                margin: "2px 0",
                borderWidth: "2px",
                borderColor: "black",
              }}
            />
            {/* Patient and Provider Info Grid */}

            <div
              className="small-font-encounter-report"
              style={{ display: "flex", flexDirection: "row" }}
            > {/* Row 1: Encounter ID and patient name */}
              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>{/* Encounter ID */}
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.encounterId?.label}: </div> 
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.encounterId?.value} </div>
              </div>

              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>{/* Patient Name */}
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.patientName?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.patientName?.value}{renderSourceTag(patientData?.source)} </div>
              </div>

            </div>

            <div
              className="small-font-encounter-report"
              style={{ display: "flex", flexDirection: "row" }}
            > {/* Row 2: Encounter Date, Health Card Number, Preferred Channel */}
              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.encounterDate?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.encounterDate?.value} </div>
              </div>

              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.patientIdentifier?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.patientIdentifier?.value} </div>
              </div>

              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.preferredChannel?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.preferredChannel?.value} </div>
              </div>
            </div>

            <div
              className="small-font-encounter-report"
              style={{ display: "flex", flexDirection: "row" }}
            > {/* Row 3: Completion Time, Patient DOB, Address */}
              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.completionTime?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.completionTime?.value} </div>
              </div>

              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.patientDOB?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.patientDOB?.value} </div>
              </div>

              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.address?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.address?.value} </div>
              </div>
            </div>

            <div
              className="small-font-encounter-report"
              style={{ display: "flex", flexDirection: "row" }}
            > {/* Row 4: Provider Name, Gender, Return Telephone Number */}
              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.providerName?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.providerName?.value} </div>
              </div>

              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.gender?.label}: </div>
                <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5}}> {encounterHash?.gender?.value} </div>
              </div>

              <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.returnPhone?.label} </div>
                  <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.returnPhone?.value} </div>
              </div>
            </div>

           {/* Row 5: Provider Designation, Phone Number, Caller Name & relationship to patient (if different from patient Name)*/}
          <div className="small-font-encounter-report" style={{ display: "flex", flexDirection: "row" }}>
            <div className="element" style={{ display: "flex", width: "100%", flexDirection:"column" }}>
            <><div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
              <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.designation?.label}: </div>
              <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.designation?.value} </div>
            </div>
            {encounterHash?.disposition?.value && encounterHash?.disposition?.value != "-" && (
                  <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                    <div className="fw-bold" style={{ textAlign: "left" }}>{encounterHash?.disposition?.label}:</div>
                    <div style={{ textAlign: "left", paddingLeft: 5}}> {encounterHash?.disposition?.value} </div>
                  </div>
            )}
            </>
            </div>
            <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
              <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.phone?.label} </div>
              <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.phone?.value} </div>
            </div>

            <div className="element" style={{ display: "flex", width: "100%", flexDirection:"column" }}>
              {/* Conditionally rendering Caller Name and Relationship to Patient */}
              {encounterHash?.patientName?.value !== encounterHash?.caller?.value && encounterHash?.caller?.value !== "-" && (
                <>
                  <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                    <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.caller?.label} </div>
                    <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5 }}> {encounterHash?.caller?.value} </div>
                  </div>

                  <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
                    <div className="fw-bold" style={{ textAlign: "left" }}>{encounterHash?.relationship?.label}:</div>
                    <div style={{ textAlign: "left", paddingLeft: 5}}> {encounterHash?.relationship?.value} </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="small-font-encounter-report" style={{ display: "flex", flexDirection: "row" }}> 
            <div className="element" style={{ display: "flex", width: "100%", flexDirection:"row" }}>
              <div className="fw-bold" style={{ textAlign: "left" }}> {encounterHash?.serviceLine?.label}: </div>
              <div style={{ display: "flex", justifyContent: "flex-start", textAlign: "left", paddingLeft: 5}}> {encounterHash?.serviceLine?.value} </div>
            </div>
          </div>

            <hr
              style={{
                margin: "2px 0",
                borderWidth: "2px",
                borderColor: "black",
              }}
            />

            {/* Questionnaire Info */}
            {encounterQuestionnaireData?.length > 0 &&
              encounterQuestionnaireData?.map(
                (encounter, index) =>
                  hasRelevantAnswer(encounter) && encounter?.responseType !== "surveyResponse" && (
                    <div key={`encounter-${index}`}>
                      <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          {encounter?.questionnaireTitle}
                          {isEditedIntakeQuestionnaire(encounter) && (
                            <Tooltip title="Questionnaire Response was updated">
                              <span style={{ cursor: "default" }}> *</span>
                            </Tooltip>
                          )}
                        </span>
                        <span>
                          {capitalizeWords(encounter?.author?.display)}
                          {" - "}
                          {dateTimeTzReport(encounter?.updatedAt)}
                        </span>
                      </div>
                      <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />

                      {/* Questionnaire */}
                      {encounter?.item?.map((data) => (
                        <div style={{ pageBreakInside: "avoid" }}>
                          <div
                            className="small-font-encounter-report"
                            style={{
                              display: "flex",
                              width: "100%",
                              alignItems: "center",
                            }}
                          >
                            {(data?.answer?.[0]?.valueString ||
                              (data?.questionType === "radio" &&
                                data?.answer?.some(
                                  (ele) => ele?.valueBoolean === true
                                )) ||
                              (data?.questionType === "checkbox" &&
                                data?.answer?.some(
                                  (ele) => ele?.valueBoolean === true
                                ))) && (
                              <div style={{ width: "30%", textAlign: "left", display: "flex", alignItems: "center", gap: "4px" }}>
                                <span>
                                  {data?.text}
                                </span>
                              </div>
                            )}
                            <div style={{ width: "70%", textAlign: "left" }}>
                              {data?.answer?.[0]?.valueString && (
                                <div  dangerouslySetInnerHTML={{__html: `${data?.answer?.[0]?.valueString}`}} />
                              )}
                              {data?.answer?.some(
                                (ele) => ele?.valueBoolean === true
                              ) && (
                                <div>
                                  {data?.answer?.map(
                                    (ele) =>
                                      ele?.valueBoolean === true && (
                                        <div key={ele.id}>{ele?.option}</div>
                                      )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                      <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />
                    </div>
                  )
              )}

            {/* Protocol Assessment Details */}

            {isContactCenterActive && hasProtocolContent(protocolResponseData) && (
              <div>
                <div
                  className="fw-bold mt-3 small-font-encounter-report"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <span>
                    Protocol Assessment - (Final Disposition: {finalDisposition}
                    )
                  </span>
                </div>
              </div>
            )}

            {protocolResponseData?.length > 0 &&
              protocolResponseData?.map((item, index) => {
                const hasContent =
                  item?.initialAssessment?.length > 0 ||
                  item?.positiveIndicators?.length > 0 ||
                  item?.careAdvice?.length > 0;

                return (
                  hasContent && (
                    <div key={`encounter-${index}`}>
                      <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />
                      <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          pageBreakInside: "avoid",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          Protocol: {item?.algorithm?.display}
                          {" - "}
                          {item?.algorithm?.category}
                        </span>
                        <span>
                          {capitalizeWords(item?.author?.display)}
                          {" - "} {dateTimeTzReport(item?.updatedAt)}
                        </span>
                      </div>

                      <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />

                      {/* Disposition */}
                      <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          pageBreakInside: "avoid",
                        }}
                      >
                        <div
                          style={{
                            width: "15%",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Disposition:
                        </div>
                        <div style={{ width: "85%", textAlign: "left" }}>
                          {item?.overrideDisposition && (
                            <div>
                              <span>
                                Override Disposition:{" "}
                                {item?.overrideDisposition}
                              </span>
                            </div>
                          )}
                          {item?.disposition && item?.overrideDisposition && (
                            <div>
                              <span>
                                Original Disposition: {item?.disposition}
                              </span>
                            </div>
                          )}
                          {item?.disposition && !item?.overrideDisposition && (
                            <div>
                              <span>{item?.disposition}</span>
                            </div>
                          )}
                          {item?.dispositionRationale && (
                            <div>
                              <span>
                                Override Rationale: {item?.dispositionRationale}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />
                      {/* Initial Assessment */}
                      {item?.initialAssessment?.length > 0 && <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          pageBreakInside: "avoid",
                        }}
                      >
                        <div
                          style={{
                            width: "15%",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Initial Assessment:
                        </div>
                        <div style={{ width: "85%", textAlign: "left" }}>
                          {item?.initialAssessment?.map((question, i) => (
                            <div key={`question-${i}`}>
                              <div>Q: {question?.question}</div>
                              <div>A: {question?.answer}</div>
                              <hr
                                style={{
                                  margin: "2px 0",
                                  borderWidth: "2px",
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                        
                      </div>}
                      {item?.initialAssessment?.length > 0 && <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />}

                      

                      {/* Positive Indicator */}
                      <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          pageBreakInside: "avoid",
                        }}
                      >
                        <div
                          style={{
                            width: "15%",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Positive Indicator:
                        </div>
                        <div style={{ width: "85%", textAlign: "left" }}>
                          {item?.positiveIndicators?.map(
                            (question, i) =>
                              question?.answer === "Yes" && (
                                <div key={`question-${i}`}>
                                  <div>
                                    <ul
                                      style={{
                                        paddingLeft: "0",
                                        marginLeft: "0",
                                        marginBottom: "0",
                                      }}
                                    >
                                      <li>{question?.questionText}</li>
                                    </ul>
                                  </div>
                                </div>
                              )
                          )}
                        </div>
                      </div>

                      <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />

                      {/* Negative Indicator */}
                      <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          pageBreakInside: "avoid",
                        }}
                      >
                        <div
                          style={{
                            width: "15%",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Negative Indicators:
                        </div>
                        <div style={{ width: "85%", textAlign: "left" }}>
                          {item?.positiveIndicators?.map(
                            (question, i) =>
                              question?.answer === "No" && (
                                <div key={`question-${i}`}>
                                  <div>
                                    <ul
                                      style={{
                                        paddingLeft: "0",
                                        marginLeft: "0",
                                        marginBottom: "0",
                                      }}
                                    >
                                      <li>{question?.questionText}</li>
                                    </ul>
                                  </div>
                                </div>
                              )
                          )}
                        </div>
                      </div>

                      <hr
                        style={{
                          margin: "2px 0",
                          borderWidth: "2px",
                          borderColor: "black",
                        }}
                      />

                      {/* Care Advice */}
                      <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          pageBreakInside: "avoid",
                        }}
                      >
                        <div
                          style={{
                            width: "15%",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Care Advice:
                        </div>
                        <div style={{ width: "85%", textAlign: "left" }}>
                          {item?.careAdvice?.map((advice, i) => (
                            <div key={`advice-${i}`}>
                              <div>
                                <ul
                                  style={{
                                    paddingLeft: "0",
                                    marginLeft: "0",
                                    marginBottom: "0",
                                  }}
                                >
                                  <li>{advice?.adviceHeading}</li>
                                  <ul>
                                    {advice?.subAdvices?.map((subItem, j) => {
                                      // Split by \n\n - first part is bullet text, second part is bold subheading
                                      const [bulletText, nextLineText] = subItem.text.split(/\n\n+/, 2);
                                      const trimmedBulletText = bulletText.trim();
                                      const trimmedBoldText = nextLineText?.trim();
                                      
                                      return (
                                        <>
                                          <li key={`subAdvice-${j}`}>
                                            {trimmedBulletText}
                                          </li>
                                          {/* {trimmedBoldText && (
                                            <div>{trimmedBoldText}</div>
                                          )} */}
                                        </>
                                      );
                                    })}
                                  </ul>
                                </ul>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <hr />
                      {isContactCenterActive &&
                        protocolResponseData?.length > 0 && (
                          <div>
                            <div
                              className="fw-bold mt-3 small-font-encounter-report"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <span>-------- END OF PROTOCOL --------</span>
                            </div>
                          </div>
                        )}
                    </div>
                  )
                );
              })}

            {/* Telephone Detai;s */}
            {isCTIEnabled && ctiMetadata?.length > 0 && (
            <>
              <div
                className="small-font-encounter-report"
                style={{
                display: "flex",
                justifyContent: "space-between",
              }}>
                <span style={{ fontWeight: "bold" }}>
                  Contact Attempts
                </span>
              </div>
              <hr
                style={{
                margin: "2px 0",
                borderWidth: "2px",
                borderColor: "black",
                }}
              />
              {ctiMetadata
                ?.filter((item) => item?.callType === "OUTBOUND")
                ?.map((item, index, arr) => {
                  const practitionerName = item?.practitionerName
                    ? capitalizeWords(item?.practitionerName)
                    : "";
                  const formattedTime = item?.startTime
                    ? moment.utc(item?.startTime).local().format("MMM-DD-YYYY HH:mm")
                    : "";

                  return (
                    <div
                      key={`encounter-${index}`}
                      className="small-font-encounter-report"
                      style={{ pageBreakInside: "avoid", display: "flex",  width: "100%", alignItems: "center"}}>
                      <div style={{ width: "30%", textAlign: "left" }}>
                        Attempt {arr.length - index}
                      </div>
                      <div style={{ width: "70%", textAlign: "left" }}>
                        {practitionerName} - {formattedTime}
                      </div>
                    </div>
                  );
                })}
                <hr
                  style={{
                  margin: "2px 0",
                  borderWidth: "2px",
                  borderColor: "black",
                }}
              />
            </>
            )}


            {/* Document Delivery Info */}
            {(hasServiceRequestDelivery ||
              internalReferrals?.length > 0 ||
              encounteredData?.documentDelivery?.some(
                (delivery) => delivery?.type === "PHARM"
              )) && (
                <>
                  {/* Service Request sent */}
                  {hasServiceRequestDelivery ? (
                    encounteredData?.documentDelivery
                      ?.filter((delivery) => delivery?.type !== "PHARM" && delivery?.type !== "HOSP")
                      ?.map((ele, index) => (
                        <div style={{ pageBreakInside: "avoid" }} key={index}>
                          <div
                            className="small-font-encounter-report"
                            style={{
                              display: "flex",
                              width: "100%",
                              alignItems: "flex-start",
                              marginBottom: "15px",
                            }}
                          >
                            <div
                              style={{
                                width: "15%",
                                textAlign: "left",
                                fontWeight: "bold",
                              }}
                            >
                              Service Request Sent:
                            </div>
                            <div style={{ width: "85%", textAlign: "left" }}>
                              <div>
                                <span>Name: {capitalizeWords(ele?.display)}</span>
                              </div>
                              <div>
                                <span>
                                  Fax:{" "}
                                  {ele?.telecom?.find((data) => data?.system === "fax")?.value || "-"}
                                </span>
                              </div>
                              <div>
                                Type: {ele?.type === "MBL" && "Lab"}
                                {ele?.type === "RADDX" && "Diagnostics"}
                                {ele?.type === "DX" && "Referral"}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : null}

                  {/* Internal referrals continue the Service Request group;
                      the label renders once only when no faxed entries exist */}
                  {internalReferrals?.map((referral, index) => (
                    <div style={{ pageBreakInside: "avoid" }} key={referral?.id || index}>
                      <div
                        className="small-font-encounter-report"
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "flex-start",
                          marginBottom: "15px",
                        }}
                      >
                        <div
                          style={{
                            width: "15%",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          {index === 0 && !hasServiceRequestDelivery
                            ? "Service Request Sent:"
                            : ""}
                        </div>
                        <div style={{ width: "85%", textAlign: "left" }}>
                          <div>
                            <span>Type: Internal Referral</span>
                          </div>
                          <div>
                            <span>
                              Referral Type:{" "}
                              {internalReferralTypeLabels[referral?.referralType] || "-"}
                            </span>
                          </div>
                          <div>
                            <span>
                              Service Line: {referral?.targetServiceLine?.display || "-"}
                            </span>
                          </div>
                          <div>
                            <span>Reason: {referral?.note?.text || "-"}</span>
                          </div>
                          {referral?.targetEncounter?.reference ? (
                            <div>
                              <span>
                                Referral Encounter Id:{" "}
                                {referral.targetEncounter.reference.split("/")?.[1]}
                              </span>
                            </div>
                          ) : null}
                          <div>
                            <span>Date: {ViewDateTime(referral?.authoredOn)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Medication Request sent */}
                  {encounteredData?.documentDelivery?.some(
                    (delivery) => delivery?.type === "PHARM"
                  ) ? (
                    <div style={{ pageBreakInside: "avoid" }}>
                      
                        {encounteredData?.documentDelivery
                          ?.filter((delivery) => delivery?.type === "PHARM")
                          ?.map((ele, index) => (
                            <div
                              className="small-font-encounter-report"
                              style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-start",
                                marginBottom: "15px",
                              }}
                            >
                              <div
                                style={{
                                  width: "15%",
                                  textAlign: "left",
                                  fontWeight: "bold",
                                }}
                              >
                                Prescription Sent:
                              </div>
                              <div
                                style={{ width: "85%", textAlign: "left" }}
                                key={index}
                              >
                                <div>
                                  <span>
                                    Name: {capitalizeWords(ele?.display)}
                                  </span>
                                </div>

                                <div>
                                  <span>
                                    Fax:{" "}
                                    {ele?.telecom?.find(
                                      (data) => data?.system === "fax"
                                    )?.value || "-"}
                                  </span>
                                </div>
                              </div>
                              </div>
                          ))}
                      
                    </div>
                  ) : null}
                </>
              )}

          </div>
          {/* Practitioner Details */}
          <div>
            <h6 className="mt-3">
              {practitionerDetails.length ? <b>Practitioner</b> : null}
            </h6>

            {/* Practitioner Signature */}
            <div className="body-info pt-0 pb-2">
              <Row>
                <Col md={4}>
                  {base64SignImg && (
                    <img
                      width={80}
                      src={base64SignImg}
                      style={{ marginLeft: "10px" }}
                    />
                  )}
                  {practitionerDetails && practitionerDetails?.name && (
                    <h6 className="info-title mt-2 mb-2 small-font-encounter-report">
                      {" "}
                      {practitionerDetails?.name?.[0]?.text
                        ?.split(" ")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")}
                    </h6>
                  )}
                  {practitionerDetails && practitionerDetails?.designation && (
                    <h5
                      className="info-details m-0 small-font-encounter-report"
                      style={{ color: "#878686" }}
                    >
                      {practitionerDetails?.designation === "nursePractitioner"
                        ? "Nurse Practitioner"
                        : practitionerDetails?.designation
                            ?.split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                            )
                            .join(" ")}
                    </h5>
                  )}
                </Col>
              </Row>
              <hr
                style={{
                  margin: "2px 0",
                  borderWidth: "2px",
                  borderColor: "black",
                }}
              />
            </div>
          </div>

          {/* Addendum Details */}
          {encounteredData?.note && encounteredData?.note.length > 0 && (
            <div
              className="small-font-encounter-report"
              style={{
                display: "flex",
                width: "100%",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  width: "15%",
                  textAlign: "left",
                  fontWeight: "bold",
                }}
              >
                Addenda:
              </div>
              <div style={{ width: "85%", textAlign: "left" }}>
                {encounteredData?.note?.map((data, index) => (
                  <div key={index} style={{ marginBottom: "8px" }}>
                    {data?.text} - Added By:{" "}
                    {capitalizeWords(data?.authorReference?.display)} -{" "}
                    {dateTimeTzReport(data?.time)}
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>
      </section>
    </>
  );
};

export default EncounterReport;
